import React from 'react';
import { Box, Divider, Popover } from '@mui/material';

import PopupAction from 'components/Misc/PopupActions/components/PopupAction';
import { Action } from 'helpers';

const NavHotspotPopup = ({ object, level, anchorEl, setAnchorEl }) => {
    const open = Boolean(anchorEl);

    const handleClose = () => setAnchorEl(null);

    return (
        <Popover
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
            transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        >
            <Box p={1}>
                <PopupAction
                    action={Action.ResetPosition}
                    object={object}
                    level={level}
                    showLabel={true}
                    onActionHandled={handleClose}
                />
            </Box>
        </Popover>
    );
};

export { NavHotspotPopup };
